<template>
  <div class="sp-index-filters-labels">
    <sp-checkbox
      v-for="item in items"
      :key="item.value"
      :label="item.title"
      :checked.prop="item.checked"
      :data-testid="TestId.admin.indexFilterLabel"
      :style="item.swatchStyle"
      @change="handleChange($event, item)"
    >
      <span slot="label" class="sp-index-filters-labels__label">{{ item.title }}</span>
    </sp-checkbox>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { TestId } from "#/test-ids";
import { useIndexFiltersStore } from "#ce/apps/SpAdmin/SpIndexFilters/store/index-filters";

const props = defineProps({ filter: { type: Object, required: true } });
const emit = defineEmits(["change"]);
const store = useIndexFiltersStore();
const items = computed(() =>
  props.filter.items.map((item) => ({
    ...item,
    swatchStyle: { "--index-filters-label-swatch-color": item.color },
    checked: (store.values[props.filter.param] ?? []).includes(item.value),
  })),
);

function handleChange(event, item) {
  store.toggleLabel(props.filter, item.value, event.target.checked);
  emit("change");
}
</script>

<style lang="scss" scoped>
.sp-index-filters-labels {
  --index-filters-label-font: var(
    --sp-comp-admin-label-filter-label-font,
    var(--sp-ref-font-weight-normal) var(--sp-ref-font-size-large) / 1 var(--sp-ref-font-family-normal)
  );

  display: grid;
  gap: var(--sp-comp-admin-label-filter-row-gap, var(--sp-ref-scale-16));

  /* The swatch in the label's colour is the checkbox. */
  > sp-checkbox {
    --sp-comp-checkbox-size: var(--sp-comp-admin-label-filter-swatch-size, var(--sp-ref-scale-32));
    --sp-comp-checkbox-border-radius: var(
      --sp-comp-admin-label-filter-swatch-border-radius,
      var(--sp-ref-border-radius-full)
    );
    --sp-comp-checkbox-background-color: var(--index-filters-label-swatch-color);
    --sp-comp-checkbox-background-color-checked: var(--index-filters-label-swatch-color);
    --sp-comp-checkbox-border-color: var(--index-filters-label-swatch-color);
    --sp-comp-checkbox-border-color-checked: var(--index-filters-label-swatch-color);
    --sp-comp-checkbox-glyph-color: var(--sp-comp-admin-label-filter-check-color, var(--sp-ref-palette-white));
    --sp-comp-checkbox-gap: var(--sp-comp-admin-label-filter-gap, var(--sp-ref-scale-12));
    --sp-comp-checkbox-align-items: center;
    --sp-comp-checkbox-label-font: var(--index-filters-label-font);
  }

  &__label {
    font: var(--index-filters-label-font);
    color: var(--sp-comp-admin-label-filter-label-color, var(--sp-sys-color-on-surface));
  }
}
</style>
